import styled from 'styled-components'
import {Link} from 'react-router-dom'
import {primary} from '../utils';

const StyledLink = styled(Link)`
    text-decoration: none;
    color: ${primary[900]};
`

export default StyledLink;